<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w100p posre  textc h100p bg43 pb40">
                <div class="posre w100p textc zindex999 pt20 ">
                    <div class="textc mt20 mb30  ">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1 ">
                                主流媒体推荐
                            </span>
                        </p>
                    </div>
            
                </div>
                <div class="zindex1 w1200 hauto mauto">
                    <img class="imgauto" style="width: 70%;" src="../../public/img/map.png">
                </div>
            
            </div>

            <div class="w100p posre  textc h100p bgfff pb40">
                <div class="posre w100p textc zindex999 pt20 ">
                    <div class="textc mt20 mb30  ">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1 ">
                                校园推广渠道
                            </span>
                        </p>
                    </div>
            
                </div>
                <div class="zindex1 w1200 hauto mauto">
                    <img class="imgauto" src="../../public/img/img42_1.png">
                </div>
            
            </div>


            <div class="w100p posre  textc h100p bg42 pb40">
                <div class="posre w100p textc zindex999 pt20 " >
                        <div class="textc mt20 mb30  ">
                            <p class="fs36 c333 disinblock posre">
                                <span class="border-bottom1 cfff">
                                APP推广
                                </span>
                            </p>
                        </div>
            
                </div>
                <div class="zindex1 w1200 hauto mauto posre">
                  
                    <div v-swiper:mySwiper="swiperOption" class="swiper-container  w80p h100p  zindex1 zoom1 indexbg">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w100p h100p" src="../../public/img/img217.png">
                                <p class="textc mt20" >
                                    <span class="bgdf5 pt5 pb5 pl15 pr15 bradius25">推荐表单</span>
                                </p>
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w100p h100p" src="../../public/img/img218.png">
                                <p class="textc mt20">
                                    <span class="bgdf5 pt5 pb5 pl15 pr15 bradius25">广告推荐</span>
                                </p>
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w100p h100p" src="../../public/img/img219.png">
                                <p class="textc mt20">
                                    <span class="bgdf5 pt5 pb5 pl15 pr15 bradius25">APP推送</span>
                                </p>
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w100p h100p" src="../../public/img/img220.png">
                                <p class="textc mt20">
                                    <span class="bgdf5 pt5 pb5 pl15 pr15 bradius25">签到任务</span>
                                </p>
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w100p h100p" src="../../public/img/img221.png">
                                <p class="textc mt20">
                                    <span class="bgdf5 pt5 pb5 pl15 pr15 bradius25">社区分销</span>
                                </p>
                            </div>
                    
                        </div>
                 
                    
                    
                    </div>

                </div>
            
            </div>

            <div class="w100p overhidden pt30 pb40">
                <div class="w1200 mauto ">
                    <div class="textc mt20 mb40  ">
                        <p class="fs36 cfff disinblock posre">
                            <span class="border-bottom1">
                                更多推广方式
                            </span>
                        </p>
                    </div>
                    <div class="w48_5p box-shadow2 mr10  bradius8 disinblock floatl textc">
                        <p class="cfff fs26 bg1f8 pb15 pt15 textc bradius8r mr-2 ml-1 ">电台主持人分享</p>
                        <div>
                            <div class="disinblock pt26 pb10 w50p ">
                                <img class="imgauto" src="../../public/img/img44.png">
                            </div>
                            <p class="pt10 pb32 disinblock w55p overflow">
                                <span class="fs16 c333 floatl">微信分享推荐</span>
                                <span class="fs16 c333 floatr">电台主播推荐</span>
                            </p>
                        </div>
                    </div>
                    <div class="w48_5p box-shadow2 ml10   bradius8 disinblock floatl textc">
                        <p class="cfff fs26 bg1f8 pb15 pt15 textc bradius8r  mr-2 ml-1">小程序推荐</p>
                        <div class="disinblock pt26 pb10 w50p">
                            <img class="imgauto" src="../../public/img/img45.png">
                            <p class="pt10 overflow  pb32 disinblock w95p">
                                <span class="fs16 c333 floatl">广告曝光</span>
                                <span class="fs16 c333 floatr">热门推荐</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    export default {
        data() {
            return {
                bgImg: require('../../public/img/rong.png'),
                swiperOption: { //swiper3
                    autoplayDisableOnInteraction: false,
                    autoplay: {
                        autoplay: 2000,
                    },
                    autoplay: true,
                    speed: 2000,
                    slidesPerView: 5,
                    centeredSlides: false,
                    // slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    loop: true,
                },
                // swiperOption: {
                //     watchSlidesProgress: true,
                //     watchSlidesVisibility: true,
                //     effect: 'coverflow',
                //     slidesPerView: 4,
                //     loop: true,
                //     centeredSlides: true,
                //     speed: 3000,
                //     autoplayDisableOnInteraction: false,
                //     // autoplay: {　
                //     //     autoplay: 2000,
                //     // },
                //     coverflowEffect: {
                //         rotate: 10,
                //         stretch: 100,
                //         depth: 50,
                //         modifier: 0,
                //         spaceBetween: 100,
                //         slideShadows: false
                //     },
                //     coverflow: {
                //         rotate: 10,
                //         stretch: 0,
                //         depth: 50,
                //         modifier: 3,
                //         slideShadows: false
                //     }

                // },
                color: 3,
                titleList: 1,
                link: 0,
                logo: 'school',

            };
        },
        components: {
            Header,
            Footer
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg42 {
        background-image: url('../../public/img/img42.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    
    .bg43 {
        background-image: url('../../public/img/img43.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        z-index: 1;
    }
</style>